import ToastificationContent from '@core/components/toastification/ToastificationContent'

import axios from 'axios'
import store from './store'

const state = store.state.app

//Function to check if user can do a tasak
const canUserAccess = (permissionName, moduleSlug) => {
  try {
    if (permissionName === 'account') return true
    if (permissionName === '/' || permissionName === undefined) return true

    if (!moduleSlug) {
      return state.user !== null &&
          (
              Array.isArray(state.user.permissions) &&
              state.user.permissions.filter(i => i.name === permissionName).length > 0 &&
              Array.isArray(state.user.revoked_permissions) &&
              state.user.revoked_permissions.filter(i => i.name === permissionName).length < 1
          )
          || state.user.roles.indexOf('Super Admin') !== -1
    }

    // If module slug is not null , we check if module is active or not. If not active , the user does not have permission for it
    const module = state.modules.filter(i => i.slug === moduleSlug && i.status === 1)
    return module.length > 0 && state.user !== null && Array.isArray(state.user.permissions) && state.user.permissions.filter(i => i.name === permissionName).length > 0 || state.user.roles.indexOf('Super Admin') !== -1
  } catch (e) {
    return false
  }
}


const is_admin_employee = ()=>{
    return state.user && state.user.is_admin_employee
}


//Check if user has specified role
const hasRole = role => {
  try {
    if (state.user && Array.isArray(state.user.roles)) return state.user.roles.includes(role)
    return false
  } catch (e) {
    return false
  }
}

// detect mobile devices
const isMobile = mobile => {
    if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
    } else {
        return false
    }
}

//Custom utility function to handle http request responses

const axiosSuccessHandler = (r, context, after_request_callback = null, success_call_back = null, failure_callback = null, show_success_message = true, show_error_message = false) => {
  if (after_request_callback) after_request_callback()
  const { data } = r
  if (data.hasOwnProperty('status') && data.status === true) {
    if (show_success_message) {
      context.$swal({
        title: 'Success',
        text: data.hasOwnProperty('message') ? data.message : 'Done successfully',
        icon: 'success',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    }
    if (success_call_back) success_call_back()
  } else if (data.hasOwnProperty('status') && data.status === false && data.hasOwnProperty('message')) {
    if (show_error_message) {
      context.$swal({
        title: 'Error!',
        text: data.message,
        icon: 'error',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    }
    if (failure_callback) failure_callback()
  } else throw 'Processing Error. Please Contact Admin'
}
//Custom utility function to handle http request exceptions
const axiosErrorHandler = (e, context, after_request_callback = null) => {
  if (after_request_callback) after_request_callback()
  if (e.hasOwnProperty('response')) {
    const { data } = e.response
    if (data.hasOwnProperty('status') && data.status === false && data.hasOwnProperty('message')) {
      context.$swal({
        title: 'Error!',
        text: data.message,
        icon: 'error',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    }

    if (data.hasOwnProperty('errors') && Array.isArray(data.errors)) {
      data.errors.forEach(item => {
        context.$toast({
          component: ToastificationContent,
          props: {
            title: item,
            message: item,
            icon: 'DeleteIcon',
            variant: 'danger',
          },
        })
      })
    }
    return false
  }
  context.$swal({
    title: 'Error!',
    text: 'Processing Error. Please Contact Admin',
    icon: 'error',
    customClass: {
      confirmButton: 'btn btn-primary',
    },
    buttonsStyling: false,
  })
}
const axiosIns = token => axios.create({
    baseURL: process.env.MIX_APP_URL? (process.env.MIX_APP_URL + "/api/"): 'http://activatewireless/api/',
  headers: { Authorization: `Bearer ${token}` },
})



// axios instance that uses auth token by default
const axiosTokenIns = token => axios.create({
  baseURL: process.env.MIX_APP_URL? (process.env.MIX_APP_URL + "/api/"): 'http://activatewireless/api/',
  headers: { Authorization: `Bearer ${state.user.token}` },
})

const isValidNumber = number => number && number.match(/^(\+\d{1,3}[- ]?)?\d{10,}$/) != null

const websiteUrl = () => process.env.MIX_APP_URL || 'https://activatewireless.com'
const appUrl = () => process.env.MIX_PORTAL_URL || 'https://activatewireless.com/dealer-porta#'


// Function to truncate the decimal digits
const toFixed = (number,digits = 3) => Math.trunc(number * (10 ** digits)) / (10 ** digits)

// Function to get fields to exporting a table
const getFieldsForExport =  fields =>  {
  let fields_in_obj = {}
  let to_skip = ['#','actions']
  fields.forEach(field => {
    if(to_skip.includes(field) ) return
    if (typeof field === 'object') fields_in_obj[field.key] = field.key
    else fields_in_obj[field] = field
  })
  return fields_in_obj;
}

export {
  canUserAccess,
  axiosSuccessHandler,
  axiosErrorHandler,
  axiosIns,
  isValidNumber,
  axiosTokenIns,
  websiteUrl,
  appUrl,
  hasRole,
  toFixed,
  getFieldsForExport,
  is_admin_employee,
  isMobile
}
